
import DefaultButton from './DefaultButton';
import { globalDirectories } from '../../globalDirectories';
import NavBar from './NavBar';

function TopBar() {
    return (
        <header className="sticky top-0 z-50 border-b border-orange-400 bg-darkgray">
            <div className="w-full flex items-center justify-between px-4 py-2 text-white">
                <div className="flex-shrink-0">
                    <div className='aspect-[1] w-full max-w-[50px] sm:max-w-[50px] md:max-w-[70px] lg:max-w-[90px]'>
                        <img src={globalDirectories.logo} alt='Logo' width={90} className='object-contain relative inset-0 w-full h-full object-cover' />
                    </div>
                </div>
                <nav className="flex gap-4 justify-center flex-grow sm:flex hidden">
                        <DefaultButton to="/"> Home </DefaultButton>
                        <DefaultButton to="/About"> About </DefaultButton>
                        <DefaultButton to="/Gallery"> Gallery </DefaultButton>
                        <DefaultButton to="/Contact"> Contact </DefaultButton>
                </nav>

                <div className="sm:hidden flex">
                    <NavBar />
                </div>

            </div>
        </header>
    );
}

export default TopBar;